import React from "react";
import sp1 from "../assets/spec11.png"; // Lisa Thompson Image
import sp2 from "../assets/spec23.png"; // Maria Garcia Image

export default function Specialists() {
    return (
        <section className="bg-[#FAFCFF] py-20 font-sans">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                
                {/* HEADER */}
                <div className="text-center mb-16 flex flex-col items-center">
                    <p className="text-[14px] tracking-[0.2em] text-[#005AAC] font-bold uppercase">
                        The Experts
                    </p>
                    <h2 className="text-[60px] md:text-[60px] font-extrabold text-[#121742] mt-2 tracking-tight">
                        Our Specialists
                    </h2>
                </div>

                {/* CARDS GRID */}
                <div className="grid lg:grid-cols-2 gap-8">
                    
                    {/* CARD 1 - Maria Garcia */}
                    <div className="bg-white p-5 rounded-[32px] shadow-[0_10px_40px_rgba(0,0,0,0.03)] flex flex-col sm:flex-row gap-6 md:gap-8 items-center sm:items-stretch hover:shadow-[0_15px_50px_rgba(0,0,0,0.06)] transition-shadow duration-300">
                        
                        {/* IMAGE */}
                        <img
                            src={sp1}
                            alt="Maria Garcia"
                            className="w-full sm:w-[220px] h-[240px] object-cover rounded-[24px]"
                        />
                        
                        {/* CONTENT */}
                        <div className="flex flex-col justify-center flex-1 py-2 text-center sm:text-left">
                            
                            {/* Stars */}
                            <div className="text-[#8C6B5D] text-[18px] tracking-[2px] mb-2">
                                ★★★★★
                            </div>
                            
                            <h3 className="text-[30px] font-bold text-[#0B1238] leading-tight">
                                Maria Garcia
                            </h3>
                            
                            <p className="text-[14px] text-[#005AAC] font-bold tracking-widest uppercase mt-2">
                                Senior Aesthetician
                            </p>
                            
                            <p className="text-[16px] text-gray-500 italic leading-relaxed mt-4 mb-6">
                                "Maria's attention to detail during my K-Sense ritual was unmatched. I've never seen my skin look so vibrant."
                            </p>
                            
                            <div className="mt-auto">
                                <a href="/book/aurora-artistry" className="text-[14px] font-bold text-[#0B1238] border-b-2 border-[#7E5537] pb-0.5 hover:text-blue-600 hover:border-blue-600 transition-colors inline-block">
                                    Book with Maria
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* CARD 2 - Lisa Thompson */}
                    <div className="bg-white p-5 rounded-[32px] shadow-[0_10px_40px_rgba(0,0,0,0.03)] flex flex-col sm:flex-row gap-6 md:gap-8 items-center sm:items-stretch hover:shadow-[0_15px_50px_rgba(0,0,0,0.06)] transition-shadow duration-300">
                        
                        {/* IMAGE */}
                        <img
                            src={sp2}
                            alt="Lisa Thompson"
                            className="w-full sm:w-[220px] h-[240px] object-contain rounded-[24px]"
                        />
                        
                        {/* CONTENT */}
                        <div className="flex flex-col justify-center flex-1 py-2 text-center sm:text-left">
                            
                            <div className="text-[#8C6B5D] text-[18px] tracking-[2px] mb-2">
                                ★★★★⯨
                            </div>

                            
                            <h3 className="text-[30px] font-bold text-[#0B1238] leading-tight">
                                Lisa Thompson
                            </h3>
                            
                            <p className="text-[14px] text-[#005AAC] font-bold tracking-widest uppercase mt-2">
                                Master Hair Stylist
                            </p>
                            
                            <p className="text-[16px] text-gray-500 italic leading-relaxed mt-4 mb-6">
                                "Lisa has an incredible eye for color. She transformed my hair while keeping it healthy and shiny."
                            </p>
                            
                            <div className="mt-auto">
                                <a href="/book/aurora-artistry" className="text-[14px] font-bold text-[#0B1238] border-b-2 border-[#7E5537] pb-0.5 hover:text-blue-600 hover:border-blue-600 transition-colors inline-block">
                                    Book with Lisa
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}
